import Information20 from '@carbon/icons-react/es/information/20';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { defaultAllowedTaskFieldsList } from '../utils';

const InfoIcon = styled(Information20)``;
const Message = styled.div`
  ${BodyShort01};
  display: flex;
  gap: var(--spacing-05);
  align-items: center;

  ${InfoIcon} {
    color: var(--blue-50);
  }
`;

const Wrapper = styled.div`
  background-color: var(--blue-10);
  border: 1px solid var(--blue-50);
  border-left-width: 4px;
  padding: var(--spacing-05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--layout-03);
`;
const StyledLink = styled(Link)`
  padding-left: var(--spacing-02);
`;

export const AssociatedFieldInfo = ({
  fieldName,
  fieldType,
  fieldId,
}: {
  fieldName: string;
  fieldType: 'PROJECT_FIELD' | 'TASK_FIELD';
  fieldId: number;
}): JSX.Element => {
  const canShowEditLink =
    defaultAllowedTaskFieldsList.includes(fieldName) &&
    fieldType === 'TASK_FIELD';

  const settingText = useTranslation('menu.label.settings');

  return (
    <Wrapper>
      <Message>
        <span>
          <InfoIcon />
        </span>
        <span>
          <FormattedMessage
            id={
              fieldType === 'PROJECT_FIELD'
                ? 'form_templates.field_configuration.project_field'
                : 'form_templates.field_configuration.task_field'
            }
            values={{
              strong: (chunks) => <strong>{chunks}</strong>,
              fieldName,
            }}
          />
          {!canShowEditLink ? (
            <>
              <FormattedMessage id="form_templates.field_configuration.redirect_to_field" />
              <StyledLink
                to={
                  fieldType === 'PROJECT_FIELD'
                    ? RoutePaths.editProjectField.replace(
                        ':fieldId',
                        fieldId.toString(),
                      )
                    : RoutePaths.editTaskField.replace(
                        ':fieldId',
                        fieldId.toString(),
                      )
                }
                target="_blank"
              >
                {settingText}
              </StyledLink>
            </>
          ) : null}
        </span>
      </Message>
    </Wrapper>
  );
};
